import { CURRENT_USER_UPSERT, USER_REMOVE } from './actions'
import { getCurrentUser, setUserToken } from '../../utils/user'

const initialState = {
  currentUser: getCurrentUser(),
}

export default function(state = initialState, { type, payload }) {
  switch (type) {
    case CURRENT_USER_UPSERT.REQUEST:
      if (payload.accessToken) {
        setUserToken(payload.accessToken)
      }
      return { ...state, currentUser: payload }
    case USER_REMOVE.REQUEST:
      const { userIns } = payload
      if (userIns) {
        state[userIns] = {}
        return { ...state }
      }
      return { ...initialState }
    default:
      return state
  }
}
